// Global file

// Captch Alt - SEO
const captchaImg = document.querySelector('.capcha img');

if (captchaImg) {
    captchaImg.alt = 'Captcha';
}

// IF THERE IS NO IMAGE
$('img').on('error', function(){ 
    var fallback = '/images/no-image.webp';
    var image = this;

    // Do not repeatedly retry the fallback itself when it is unavailable.
    if (image.dataset.noImageFallback === '1') {
        return;
    }

    image.dataset.noImageFallback = '1';
    image.removeAttribute('srcset');
    $(image).attr('src', fallback);
});

// QUICK VIEW
$(document).on('click', '.JSQuickViewButton', function() {
    $('#JSQuickView').modal('show');
    $('#JSQuickViewContent').html('<img class="gif-loader" src="'+base_url+'images/quick_view_loader.gif">');	
    $.post(base_url + 'quick-view', { roba_id: $(this).data('roba_id') }, function(response) {
        $('#JSQuickViewContent').html(response);
    });	
});
$(document).on('click', '.JSQuickViewGalleryControl, .JSQuickViewGalleryThumbnail', function() {
    var media = $(this).closest('.quick-view-media');
    var thumbnails = media.find('.JSQuickViewGalleryThumbnail');
    var currentIndex = thumbnails.index(thumbnails.filter('.is-active'));
    var nextIndex = $(this).hasClass('JSQuickViewGalleryThumbnail')
        ? parseInt($(this).data('index'), 10)
        : (currentIndex + parseInt($(this).data('step'), 10) + thumbnails.length) % thumbnails.length;
    var selected = thumbnails.eq(nextIndex);

    media.find('.quick-view-image').attr({
        src: selected.find('img').attr('src'),
        alt: selected.find('img').attr('alt')
    });
    thumbnails.removeClass('is-active').attr('aria-pressed', 'false');
    selected.addClass('is-active').attr('aria-pressed', 'true');
});
$(document).on('click', '#JSQuickViewCloseButton', function() { 
    $('#JSQuickView').modal('hide');
});
